import React, { useMemo } from 'react';
import { Col, Form, Row, Switch } from 'antd';
import Input from '@/components/common/input';
import './index.scss';
import '../../style.scss';
import PhoneInput from '@/components/common/phoneInput';
import CustomSelect from '@/components/common/select';
import { setFieldValue } from '@/utils/form';
import { useSelector } from 'react-redux';
import { MapSearchInput } from '@/components/common/input/googleMapInput';

const AddressInformation = ({ item, values, form, ...props }) => {
  const countries = useSelector((state) => state.application?.config?.fulfilment_countries);

  const { countryOption, stateOption } = useMemo(() => {
    if (countries)
      return {
        countryOption: countries.map((_) => ({ value: _.code, label: _.name })),
        stateOption: countries.reduce(
          (acc, _) => ({
            ...acc,
            [_.code]: _.states.map((state) => ({ value: state.code, label: state.name })),
          }),
          {},
        ),
      };
    return { countryOption: [], stateOption: {} };
  }, [countries]);

  return (
    <>
      <p className="title">Address Information</p>
      <Form.Item name={['shipping_addresses', 'id']} style={{ display: 'none' }} />
      <Input
        label="Name"
        name={['shipping_addresses', 'label']}
        rules={[{ required: true, message: 'Please input address name!' }]}
        placeholder="e.g Home"
      />
      <Form.Item
        label="Address"
        name={['shipping_addresses', 'address_1']}
        rules={[{ required: true, message: 'Please input your address!' }]}
        getValueFromEvent={(v) => {
          setFieldValue(form, 'shipping_addresses', {
            address_1: v?.address || '',
            country_code: v?.country?.short_name || '',
            state: v?.state?.short_name || '',
            postcode: v?.postal_code?.short_name || '',
          });
          return v?.address || '';
        }}
      >
        <MapSearchInput placeholder="e.g 1279 Raewo Circle" />
      </Form.Item>
      <Input
        label="Apartment, Suite, etc (optional)"
        name={['shipping_addresses', 'address_2']}
        placeholder="e.g 1279 Unit 490"
      />
      <Input
        label="Suburb"
        name={['shipping_addresses', 'suburb']}
        rules={[{ required: true, message: 'Please input your suburb!' }]}
        placeholder=""
      />
      <Row gutter={[8, 8]}>
        <Col span={8}>
          <CustomSelect
            label="Country"
            name={['shipping_addresses', 'country_code']}
            rules={[{ required: true, message: 'Please select your country!' }]}
            options={countryOption}
          />
        </Col>
        <Col span={8}>
          <CustomSelect
            label="State"
            name={['shipping_addresses', 'state']}
            fieldKey={['shipping_addresses', 'sight']}
            rules={[{ required: true, message: 'Please select your state!' }]}
            options={stateOption?.[values?.shipping_addresses?.country_code] || []}
          />
        </Col>
        <Col span={8}>
          <Input
            label="Postal Code"
            name={['shipping_addresses', 'postcode']}
            fieldKey={['shipping_addresses', 'postcode']}
            rules={[{ required: true, message: 'Please input your postcode!' }]}
          />
        </Col>
      </Row>

      <div className="address-default-checker">
        <Form.Item name={['shipping_addresses', 'is_preferred']} valuePropName="checked">
          <Switch />
        </Form.Item>
        <span>Make this my default address</span>
      </div>

      <p className="title">Business Information</p>
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Input label="Business Name" placeholder="e.g Newton Sweets Corner" />
        </Col>
        <Col span={12}>
          <Input label="Branch" placeholder="e.g Sydney" />
        </Col>
      </Row>
      <Input label="Email" placeholder="e.g business@mymail.com.au" />
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Form.Item label="Contract Number">
            <PhoneInput
              value=""
              countryCode="au"
              separateDialCode
              onPhoneNumberChange={(validate, localNumber, info, globalNumber) => {}}
              preferredCountries={[]}
              onlyCountries={['au', 'nz']}
              placeholder="0412 345 678"
              inputClassName="ant-input"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
export default AddressInformation;
